import { patientActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.caseMgrs };
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.ptno === action.payload ) {
                delete state[x.id];
            }
        })
    }
})


